import { useTheme } from '@mui/material'

// ----------------------------------------------------------------------

export function useCalendarColors() {
  const { palette } = useTheme()

  return {
    calendarColorOptions: [
      palette.info.dark,
      palette.info.main,
      palette.secondary.main,
      palette.success.main,
      palette.info.darker,
      palette.warning.main,
      palette.error.main,
      palette.error.darker,
    ],
  }
}
